import { ProfilesLoader } from './loader';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from '../../../../constants/moduleCodes';
import { get2bapProfilesModuleUrl, getProfilesSummaryViewUrl } from './getUrls';
import { RouterRedirect } from '../../../../utils';
import { ProfilesRouterHelper } from './helper/ProfilesRouterHelper';
import AppAction from '../../../../action/appAction';
import { ProfilesAuthErrorPage } from './views/error/ProfilesAuthErrorPage';

export default {

  path: get2bapProfilesModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], () => {
      callback(new RouterRedirect(getProfilesSummaryViewUrl()));
    });
  },

  getComponent(nextState, callback) {
    const error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_2BAP);
    if (error) {
      callback(error);
      return;
    }

    ProfilesLoader.load(callback);
  },

  getChildRoutes(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, [
        {
          path: ProfilesRouterHelper.SUMMARY_VIEW_PATH,
          component: require('./views/summaryView/SummaryViewPage').SummaryViewPage
        },
        {
          path: ProfilesRouterHelper.LEARNER_PROFILE_PATH,
          component: require('./views/learnerProfile/LearnerProfilePage').LearnerProfilePage
        },
        {
          path: ProfilesRouterHelper.SUMMARY_EDIT_PATH,
          component: require('./views/summaryEdit/SummaryEditPage').SummaryEditPage
        },
        {
          path: ProfilesRouterHelper.CLASS_EDIT_PATH,
          getComponent: () => loadComponent(import('./views/classEdit/ClassEditContainer'), m => m.ClassEditContainer)
        },
        {
          path: ProfilesRouterHelper.LEARNER_EDIT_PATH,
          getComponent: () => loadComponent(import('./views/learnerEdit/LearnerEditContainer'), m => m.LearnerEditContainer)
        }
      ], '2bap-profiles-chunk');
    });
  }

}

export const profilesAuthErrorRoute = {
  path: ProfilesRouterHelper.AUTH_ERROR_PATH,
  component: ProfilesAuthErrorPage
};

async function loadComponent(componentLoader, componentCb) {
  AppAction.toggleGlobalSpinner(true);
  const module = await componentLoader;
  AppAction.toggleGlobalSpinner(false);
  return componentCb(module);
}
